import { __awaiter, __generator } from "tslib";
import { IconButton, MenuItem, TableCell, TextField } from '@material-ui/core';
import { GetApp } from '@material-ui/icons';
import { Label } from '@react/components';
import { useLocaleDateTime } from '@react/lib/date';
import { useErrorToast, useSuccessToast } from '@react/lib/hooks';
import { useTranslations } from '@react/lib/i18n';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { useSIDEExportDataByRecipe, useSIDERecipesQuery } from './hooks';
import { RecipesContainer, StyledSelect, StyledTableRow, } from './SIDEExportAction.styled';
import { TimeFrames } from './types';
import { getDateFieldValue, getTimeFrameDates } from './utils';
var SIDEExportAction = function (props) {
    var t = useTranslations().t;
    var localeDateTime = useLocaleDateTime();
    var _a = useState(''), selectedSIDERecipeId = _a[0], setSelectedSIDERecipeId = _a[1];
    var _b = useState(TimeFrames.Today), selectedTimeFrame = _b[0], setSelectedTimeFrame = _b[1];
    var _c = useState(getDateFieldValue(localeDateTime)), startDate = _c[0], setStartDate = _c[1];
    var _d = useState(getDateFieldValue(localeDateTime)), endDate = _d[0], setEndDate = _d[1];
    var _e = useState(true), startDateDisabled = _e[0], setStartDateDisabled = _e[1];
    var _f = useState(true), endDateDisabled = _f[0], setEndDateDisabled = _f[1];
    var _g = useState(false), exportSuccessToastVisible = _g[0], setExportSuccessToastVisible = _g[1];
    var _h = useState(false), exportErrorToastVisible = _h[0], setExportErrorToastVisible = _h[1];
    var _j = useState(true), isDownloadEnabled = _j[0], setIsDownloadEnabled = _j[1];
    var _k = useState(false), isDownloading = _k[0], setIsDownloading = _k[1];
    var _l = useSIDERecipesQuery(), data = _l.data, recipesLoading = _l.isLoading;
    var sideRecipes = ((data && data.data) || []).sort(function (a, b) {
        return a.name.localeCompare(b.name);
    });
    var onDownloadSuccess = function () {
        setExportSuccessToastVisible(true);
        setIsDownloading(false);
    };
    var onDownloadFailure = function () {
        setExportErrorToastVisible(true);
        setIsDownloading(false);
    };
    var _m = useSIDEExportDataByRecipe({
        sideRecipeId: selectedSIDERecipeId,
        from: startDate,
        to: endDate,
        onDownloadSuccess: onDownloadSuccess,
        onDownloadFailure: onDownloadFailure,
    }), download = _m.download, fileUrl = _m.fileUrl, ref = _m.ref, fileName = _m.fileName;
    var updateTimeFrame = function () {
        setStartDateDisabled(selectedTimeFrame !== TimeFrames.CustomDates);
        setEndDateDisabled(selectedTimeFrame !== TimeFrames.CustomDates);
        if (selectedTimeFrame !== TimeFrames.CustomDates) {
            var _a = getTimeFrameDates(localeDateTime, selectedTimeFrame), start = _a.start, end = _a.end;
            setStartDate(getDateFieldValue(localeDateTime, start));
            setEndDate(getDateFieldValue(localeDateTime, end));
        }
    };
    useEffect(function () {
        if (selectedTimeFrame) {
            updateTimeFrame();
        }
    }, [selectedTimeFrame]);
    useEffect(function () {
        setIsDownloadEnabled(!!selectedSIDERecipeId && startDate <= endDate);
    }, [selectedSIDERecipeId, startDate, endDate]);
    useErrorToast(exportErrorToastVisible, {
        title: t.SuperAdmin.DataExport.ToastFailureTitle,
        message: t.SuperAdmin.DataExport.ToastFailureDescription,
    });
    useSuccessToast(exportSuccessToastVisible, {
        title: t.SuperAdmin.DataExport.ToastSuccessTitle,
        message: t.SuperAdmin.DataExport.ToastSuccessDescription,
    });
    var onChangeSIDERecipe = function (event) {
        setSelectedSIDERecipeId(String(event.target.value));
    };
    var onChangeTimeFrame = function (event) {
        setSelectedTimeFrame(event.target.value);
    };
    var onChangeStartDate = function (event) {
        setStartDate(String(event.target.value));
    };
    var onChangeEndDate = function (event) {
        setEndDate(String(event.target.value));
    };
    var saveToCSV = function () { return __awaiter(void 0, void 0, void 0, function () {
        var fileNameSuffix;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    fileNameSuffix = props.filenameSuffix + " " + startDate + " " + endDate;
                    return [4 /*yield*/, download(fileNameSuffix)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement(StyledTableRow, { "data-testid": "side_row" },
        React.createElement(TableCell, null,
            React.createElement("h2", null, props.title),
            React.createElement("p", null, props.subtitle),
            React.createElement(RecipesContainer, null, !recipesLoading && sideRecipes.length > 0 && (React.createElement(React.Fragment, null,
                React.createElement(Label, null, t.SuperAdmin.DataExport.RecipeLabel),
                React.createElement(StyledSelect, { disableUnderline: true, label: t.SuperAdmin.DataExport.RecipeLabel, onChange: onChangeSIDERecipe, value: selectedSIDERecipeId, "data-testid": "side_recipe" }, sideRecipes.map(function (recipe) { return (React.createElement(MenuItem, { key: "side-" + recipe.id, value: recipe.id.toString() }, recipe.id + " - " + recipe.name + (recipe.status === 'Inactive'
                    ? " [" + t.SuperAdmin.DataExport.SIDERecipeInactive + "]"
                    : ''))); })))))),
        React.createElement(TableCell, null,
            React.createElement(Label, null, t.SuperAdmin.DataExport.TimeFrameLabel),
            React.createElement(StyledSelect, { disableUnderline: true, value: selectedTimeFrame, label: t.SuperAdmin.DataExport.TimeFrameLabel, onChange: onChangeTimeFrame, "data-testid": "side_timeFrame" },
                React.createElement(MenuItem, { value: TimeFrames.Today }, t.SuperAdmin.DataExport.Today),
                React.createElement(MenuItem, { value: TimeFrames.Yesterday }, t.SuperAdmin.DataExport.Yesterday),
                React.createElement(MenuItem, { value: TimeFrames.Last7Days }, t.SuperAdmin.DataExport.Last7Days),
                React.createElement(MenuItem, { value: TimeFrames.LastWeek }, t.SuperAdmin.DataExport.LastWeek),
                React.createElement(MenuItem, { value: TimeFrames.ThisMonth }, t.SuperAdmin.DataExport.ThisMonth),
                React.createElement(MenuItem, { value: TimeFrames.LastMonth }, t.SuperAdmin.DataExport.LastMonth),
                React.createElement(MenuItem, { value: TimeFrames.Last12Months }, t.SuperAdmin.DataExport.Last12Months),
                React.createElement(MenuItem, { value: TimeFrames.CustomDates }, t.SuperAdmin.DataExport.CustomDates))),
        React.createElement(TableCell, null,
            React.createElement(TextField, { type: "date", label: t.SuperAdmin.DataExport.StartDateLabel, disabled: startDateDisabled, value: startDate, InputLabelProps: {
                    shrink: true,
                }, onChange: onChangeStartDate, "data-testid": "side_startDate" })),
        React.createElement(TableCell, null,
            React.createElement(TextField, { type: "date", label: t.SuperAdmin.DataExport.EndDateLabel, disabled: endDateDisabled, value: endDate, InputLabelProps: {
                    shrink: true,
                }, onChange: onChangeEndDate, "data-testid": "side_endDate" })),
        React.createElement(TableCell, null,
            React.createElement(IconButton, { onClick: saveToCSV, disabled: isDownloading || !isDownloadEnabled, "data-testid": "side_btnSaveToCSV" },
                React.createElement(GetApp, null)),
            React.createElement("a", { href: fileUrl, download: fileName, hidden: true, ref: ref }))));
};
var ɵ0 = SIDEExportAction;
export default SIDEExportAction;
export { ɵ0 };
